import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { JSONPath } from 'jsonpath-plus'
import {
  Panel,
} from 'react-instantsearch-dom'
import PropTypes from 'prop-types'
import RctCard from '../RctCards/RctCard'
import RctCardContent from '../RctCards/RctCardContent'

import ClientStorage from '../../common/ClientStorage'

import './index.css'


class SisterCategories extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dataMenu: undefined,
    }
    this.clientStorage = new ClientStorage()
  }

  componentDidMount() {
    this.clientStorage.getMenuCategories().then((response) => {
      const dataMenu = response
      this.setState({ dataMenu })
    })
  }

  getSisterCategories = (dataMenu, originalCategories) => {
    const [first, second, third] = originalCategories

    let child
    let sisterCategories = []
    let categoryFatherLabel
    let firstOrderCategory
    if (first && dataMenu) {
      const level1 = JSONPath({ path: `$[?(@.label=="${first}")]`, json: dataMenu })[0]
      if (level1) {
        sisterCategories = level1.categoriesLevel2.map(cat => cat.label)
        categoryFatherLabel = first
      }
      if (level1 && second) {
        sisterCategories = level1.categoriesLevel2.map(cat => cat.label)
        const level2 = JSONPath({ path: `$[?(@.label=="${first}")].categoriesLevel2[?(@.label=="${second}")]`, json: dataMenu })[0]
        categoryFatherLabel = first
        child = second
        if (level2 && third) {
          categoryFatherLabel = level2.label
          sisterCategories = level2.categoriesLevel3.map(cat => cat.label)
          child = third
          firstOrderCategory = first
        }
      }
    }

    return {
      firstOrderCategory, sisterCategories, categoryFatherLabel, categoryChild: child,
    }
  }

  renderCategory = (firstOrderCategory, categoryFatherLabel, sisterCategories, selectedCategory) => sisterCategories.map((category, index) => {
    const selectedClass = selectedCategory === category ? ' selected-category' : ''
    if (firstOrderCategory) {
      return (
        <li key={index}>
          <Link
            className={`sister-categories ${selectedClass}`}
            to={
              `/category/${firstOrderCategory.replace(/ /g, '_')}/${
                categoryFatherLabel.replace(/ /g, '_')}/${
                category.replace(/ /g, '_')}`
            }
          >
            {category}
          </Link>
        </li>
      )
    }
    return (
      <li key={index}>
        <Link
          className={`sister-categories ${selectedClass}`}
          to={
            `/category/${
              categoryFatherLabel.replace(/ /g, '_')}/${
              category.replace(/ /g, '_')}`
          }
        >
          {category}
        </Link>
      </li>
    )
  })

  render() {
    const { originalCategories } = this.props
    const { dataMenu } = this.state
    const {
      sisterCategories, categoryFatherLabel, categoryChild, firstOrderCategory,
    } = this.getSisterCategories(dataMenu, originalCategories)
    if (sisterCategories.length > 0) {
      return (
        <RctCard className="price" customStyles={{ borderRadius: '12px' }}>
          <RctCardContent>
            <Panel
              header={categoryChild === categoryFatherLabel ? null : categoryFatherLabel}
              className="mb-20"
            >
              <ul className="sister-categories__list">
                { this.renderCategory(firstOrderCategory, categoryFatherLabel, sisterCategories, categoryChild) }
              </ul>

            </Panel>
          </RctCardContent>
        </RctCard>
      )
    }
    return <div />
  }
}

export default SisterCategories


SisterCategories.defaultProps = {
  originalCategories: [],
}

SisterCategories.propTypes = {
  originalCategories: PropTypes.array,
}
